import { BaseImageLoadingType } from 'core/components/image/BaseImageLoadingType.ts';

export const BaseImageConfig = {
	baseImageLoadingTypes: [
		BaseImageLoadingType.LAZY,
		BaseImageLoadingType.EAGER,
		BaseImageLoadingType.AUTO,
	],
	defaultLoadingType: BaseImageLoadingType.LAZY,
};
